<sdc-app-header></sdc-app-header>

<div >
  <sdc-app-sidebar ></sdc-app-sidebar>
  <div class="main-content" >
    <router-outlet></router-outlet>
  </div>
</div>

<sdc-app-footer></sdc-app-footer>